import React from 'react';

import MARKETBASE_THEME from '@dashboard/contexts/ThemeManager/theme';
import { Box, Stack, Typography } from '@mui/material';

type Props = {
  title: string;
  primaryValue: JsxNode;
  secondaryValue?: JsxNode;
};

export default function ReportBarMetricMarkup({ title, primaryValue, secondaryValue }: Props) {
  return (
    <Stack spacing={0.5}>
      <Box>
        <Typography
          variant="overline"
          color="text.secondary"
          sx={{ lineHeight: 1, fontSize: MARKETBASE_THEME.typography.pxToRem(11) }}
        >
          {title}
        </Typography>
      </Box>
      <Stack direction="row" spacing={1} alignItems="baseline">
        <Typography variant="h6" component="span" fontWeight="normal">
          {primaryValue}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {secondaryValue}
        </Typography>
      </Stack>
    </Stack>
  );
}

type ReportBarMetricErrorProps = {
  title: string;
};
export function ReportBarMetricError({ title }: ReportBarMetricErrorProps) {
  return (
    <Stack spacing={0.5}>
      <Box>
        <Typography
          variant="overline"
          color="text.secondary"
          sx={{ lineHeight: 1, fontSize: MARKETBASE_THEME.typography.pxToRem(11) }}
        >
          {title}
        </Typography>
      </Box>
      <Stack direction="row" spacing={1} alignItems="center" height={24}>
        <Typography variant="body2" color="text.secondary">
          Timeout
        </Typography>
      </Stack>
    </Stack>
  );
}
